import handleMethod from '../Utils/APIutils/handleMethod';
import axios from 'axios';

class DeviceAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/${id}` });
  }

  async getByStore(storeId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/by-store/${storeId}` });
  }

  async getStoreHistory(storeId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/store/${storeId}/history` });
  }

  async getDeviceHistory(deviceId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/${deviceId}/history` });
  }

  async getOffline(minutesThreshold = 30, clientId = null, storeId = null) {
    let url = `api/gatewaycontagem/devices/offline?minutesThreshold=${minutesThreshold}`;
    if (clientId) url += `&clientId=${clientId}`;
    if (storeId) url += `&storeId=${storeId}`;
    return handleMethod({ type: 'GET', method: url });
  }

  async list(queryString = '') {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices?${queryString}` });
  }

  async getDistinctModels() {
    return handleMethod({ type: 'GET', method: 'api/gatewaycontagem/devices/models' });
  }

  async create(data) {
    return handleMethod({ type: 'POST', method: 'api/gatewaycontagem/devices', params: data });
  }

  async update(id, data) {
    return handleMethod({ type: 'PUT', method: `api/gatewaycontagem/devices/${id}`, params: data });
  }

  async updateStatus(id, status) {
    return handleMethod({ type: 'PATCH', method: `api/gatewaycontagem/devices/${id}/status?status=${status}` });
  }

  async updateHeartbeat(id) {
    return handleMethod({ type: 'PATCH', method: `api/gatewaycontagem/devices/${id}/heartbeat` });
  }

  async remove(id) {
    return handleMethod({ type: 'DELETE', method: `api/gatewaycontagem/devices/${id}` });
  }

  async associate(storeId, deviceIds) {
    return handleMethod({ type: 'POST', method: `api/gatewaycontagem/devices/associate/${storeId}`, params: deviceIds });
  }

  async getStatsByClient(queryString = '') {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/stats?${queryString}` });
  }

  async getZones(deviceId) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/devices/${deviceId}/zones` });
  }

  async getZoneMetrics(deviceId, startDate, endDate, period = 'HOURLY', zoneIds = null) {
    let query = `api/gatewaycontagem/devices/${deviceId}/zone-metrics?period=${period}`;
    if (startDate) query += `&startDate=${new Date(startDate).toISOString()}`;
    if (endDate) query += `&endDate=${new Date(endDate).toISOString()}`;
    if (zoneIds && (Array.isArray(zoneIds) ? zoneIds.length > 0 : String(zoneIds).trim().length > 0)) {
      query += `&zoneIds=${Array.isArray(zoneIds) ? zoneIds.join(',') : zoneIds}`;
    }
    return handleMethod({ type: 'GET', method: query });
  }

  async getLiveImageBlob(id, storeId = null) {
    const session = JSON.parse(window.localStorage.getItem('session'));
    const url = storeId
      ? `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/devices/${id}/image?storeId=${storeId}`
      : `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/devices/${id}/image`;
    const response = await axios({
      method: 'GET',
      url,
      responseType: 'blob',
      headers: {
        Authorization: session?.accessToken ? `Bearer ${session.accessToken}` : null,
      }
    });
    return response.data;
  }

  async uploadAutoCadImage(deviceId, fileBlob) {
    const session = JSON.parse(window.localStorage.getItem('session'));
    const url = `${process.env.REACT_APP_WEBAPI_URL}/api/gatewaycontagem/devices/${deviceId}/autocad`;
    const formData = new FormData();
    formData.append('file', fileBlob, 'autocad.jpg');
    const response = await axios({
      method: 'POST',
      url,
      data: formData,
      headers: {
        Authorization: session?.accessToken ? `Bearer ${session.accessToken}` : null,
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  }
}

export const deviceAPI = new DeviceAPI();
